import { render, staticRenderFns } from "./MenuDisplay.vue?vue&type=template&id=1465f61a&scoped=true"
import script from "./MenuDisplay.vue?vue&type=script&lang=js"
export * from "./MenuDisplay.vue?vue&type=script&lang=js"
import style0 from "./MenuDisplay.vue?vue&type=style&index=0&id=1465f61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1465f61a",
  null
  
)

export default component.exports